import { EmpresaStatus } from '../../types/empresa';
import { EmpresaAnalise } from '../../types/empresaApproval';

export const empresaStatusPresentation: Record<EmpresaStatus, { label: string; className: string }> = {
  pendente: { label: 'Pendente de aprovação', className: 'bg-amber-100 text-amber-800' },
  ativo: { label: 'Ativa', className: 'bg-emerald-100 text-emerald-800' },
  inativo: { label: 'Inativa', className: 'bg-gray-100 text-gray-700' },
  bloqueado: { label: 'Bloqueada após rejeição', className: 'bg-red-100 text-red-800' },
};

export const analisePresentation: Record<EmpresaAnalise['decisao'], { label: string; className: string }> = {
  aprovado: { label: 'Aprovada', className: 'bg-emerald-100 text-emerald-800' },
  rejeitado: { label: 'Rejeitada', className: 'bg-red-100 text-red-800' },
};
